import styled from "styled-components/macro";
import { makeStyles } from "@mui/styles";
import { md } from "../../styles/responsive";
import { FormControl } from "@mui/material";
// import banner002 from "../../assets/images/banner002.png";

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const CarouselIMG = styled.img`
  width: 100%;
  display: flex;
`;

export const FormInputSelectHeader = styled(FormControl)`
  display: block;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #fff;
  background-clip: padding-box;
  border: 0!important;
  border-radius: 6px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  // margin-bottom: 1rem !important;
  .MuiOutlinedInput-input {
    font-size: 24px;
    font-weight:600;
    min-height: auto;
  }
  .MuiOutlinedInput-notchedOutline{
    border: 0!important;
  }
  .MuiSelect-select{
    min-height: auto !important;
  }
  .MuiInput-underline:before {
    border-bottom: none !important;
  }
  .MuiInput-underline:after {
    border-bottom: none !important;
  }
  .MuiInputBase-root {
    width: 100%;
  }
  .MuiInputBase-root {
    font-weight: 500 !important;
  }
  .MuiInput-underline {
    &:before {
      position: relative !important;
    }
  }
`;

export const FormInputSelect = styled(FormControl)`
  display: block;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #fff;
  background-clip: padding-box;
  // border: 1px solid #c5c5c5;
  border-radius: 6px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  // margin-bottom: 1rem !important;

  .MuiInput-underline:before {
    border-bottom: none !important;
  }
  .MuiInput-underline:after {
    border-bottom: none !important;
  }
  .MuiInputBase-root {
    width: 100%;
  }
  .MuiInputBase-root {
    font-weight: 500 !important;
  }
  .MuiInput-underline {
    &:before {
      position: relative !important;
    }
  }
`;

const config = {
  theFontTitle: {
    fontSize: "34px",
    ...md("sm", {
      fontSize: "34px",
    }),
    ...md("md", {
      fontSize: "54px",
    }),
    ...md("lg", {
      fontSize: "64px",
    }),
  },

  theFont: {
    fontSize: "14px",
    ...md("md", {
      fontSize: "14px",
      textAlign: "justify",
    }),

    ...md("lg", {
      fontSize: "14px",
      textAlign: "justify",
    }),
  },

  theFont_: {
    fontSize: "14px",
    ...md("md", {
      fontSize: "14px",
      width: "60%",
    }),

    ...md("xmd", {
      fontSize: "14px",
      width: "50%",
    }),

    ...md("lg", {
      fontSize: "14px",
      width: "55%",
    }),
  },

  theHeadTitle: {
    color: "#FFF !important",
  },

  theHeadTitle_: {
    color: "#000 !important",
  },

  theFlexHeader: {
    display: "block",
    // marginBottom: "1rem",

    ...md("md", {
      display: "flex",
      alignItems: "center",
      justifyContent: 'space-between'
      // width: "50%"
    }),
  },

  theFlexHeader2: {
    display: "flex",
    alignItems: "center",
    justifyContent: 'space-between'
  },

  theHeaderSelect: {
    width: "100%",

    ...md("md", {
      width: "20%"
    }),
  },

  theCardWarehouse: {
    background: "#AC5500",
    padding: "1rem",
    borderRadius: "6px",
  },

  theCardUser: {
    background: "#FF9200",
    padding: "1rem",
    borderRadius: "6px",
  },

  theWx: {
    width: "100%",
    marginBottom: "1rem",
    ...md("md", {
      width: "20%",
      marginBottom: 0,
    }),
  },

  theWxBtn: {
    width: "100%",
    ...md("md", {
      width: "15%",
      margin: "0 auto"
    }),
  },

  theTab: {
    padding: ".4rem 1.5rem",
  },

  theTabActive: {
    fontWeight: "600",
    color: "#FF9200",
    padding: ".4rem 1.5rem",
  },

  theFlexAction: {
    display: "block",
    marginBottom: "1rem",

    ...md("md", {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
      // width: "50%"
    }),
  },
  theFlex_: {
    display: "block",

    ...md("md", {
      display: "flex",
      alignItems: "center",
    }),
  },

  theFlexFilter: {
    display: "block",
    marginBottom: "1rem",
    ...md("md", {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      width: "30%"
    }),
  },

  theFlexBtn: {
    display: "block",
    marginBottom: "1rem",
    ...md("md", {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    }),
  },

  theFlexBtn_: {
    display: "block",
    ...md("md", {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }),
  },

  theCustomActionBtn: {
    color: "#1A5386",
    background: "#fff",
    padding: ".4rem 1rem",
    display: "flex",
    // marginBottom: "1rem",
    borderBottom: "1px solid #1A5386",
    borderRight: "0",
    cursor: "pointer",

    ...md("md", {
      marginLeft: "1rem",
      marginBottom: 0,
      borderRight: "1px solid #1A5386",
      borderBottom: "0",
    }),
  },

  theCustomActionBtn_: {
    color: "#1A5386",
    background: "#fff",
    padding: ".4rem 1rem",
    display: "flex",
    marginBottom: "1rem",
    cursor: "pointer",

    ...md("md", {
      //   marginLeft: "1rem",
      marginBottom: 0,
    }),
  },

  theCustomActionBtnFill: {
    color: "#fff",
    background: "#1A5386",
    padding: ".4rem 1rem",
    display: "flex",
    marginBottom: "1rem",
    borderRadius: "10px",
    cursor: "pointer",

    ...md("md", {
      marginLeft: "1rem",
      marginBottom: 0,
    }),
  },

  theCustomActionBtnFill_: {
    color: "#fff",
    background: "#1A5386",
    padding: ".4rem 1rem",
    display: "flex",
    marginBottom: "1rem",
    borderRadius: "10px",
    cursor: "pointer",

    ...md("md", {
      marginLeft: "1rem",
      marginBottom: 0,
    }),
  },

  theAddCustomActionBtnFill: {
    color: "#fff",
    background: "#1A5386",
    padding: ".5rem 2rem",
    display: "flex",
    marginBottom: "1rem",
    borderRadius: "6px",
    cursor: "pointer",

    ...md("md", {
      marginLeft: "1rem",
      marginBottom: 0,
    }),
  },

  theBottom: {
    margin: "0 0 .8rem 0 !important",
    ...md("md", {
      margin: "0 0.8rem !important",
    }),
  },

  theBox: {
    position: "relative",
    width: "100%",
    overflow: "scroll"
  },

  theRow: {
    ...md("md", {
      display: "flex",
      overflowX: "scroll",
      width: "1440px"
    }),
  },

  theGap: {
    marginRight: "5rem"
  },
  theCard: {
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
  },
  theTotal: {
    // width: "23%",
    // margin: "0 2rem 0 auto"
  },
  theDetailRow: {
    padding: "1rem 16px!important"
  },
  theDetailOpen: {
    padding: "0!important"
  },
  theQuantityBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: "0 0 1rem"
  },
  theQuantityField: {
    width: '60%',
    padding: "0 10px 4px"
  },
  theUnderLineLabel: {
    color: "#1a5386!important",
    fontWeight: "600!important",
    textDecoration: "underline",
    cursor: "pointer"
  },
  theIconButton: {
    borderRadius: '5px',
    border: "1px solid #707070",
    margin: "5px",
    display: "flex",
    justifyContent: 'center',
    alignItems: "center",
    padding: "4px"
  },
  theIconButtonSelected: {
    borderRadius: '5px',
    border: "1px solid #1A5386",
    display: "flex",
    justifyContent: 'center',
    alignItems: "center",
    padding: "4px",
    background: "#1A5386"
  },
  theGridOdd: {
    background: "#E0F0F7",
    padding: "1rem 16px!important",
  },
  theGridEven: {
    background: "#fff",
    padding: "1rem 16px!important"
  },
  theGFlex: {
    borderTop: "1px solid #707070",
    borderBottom: "1px solid #707070",
    padding: "16px 0",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: "center"
  },
  theGFName: {
    width: "20%"
  },
  theGFItem: {
    width: "80%",
    display: 'inline-flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  theGFIBox: {
    width: "18%",
    marginRight: "50px",
    marginBottom: "10px"
  },
  theAddtoCartBtn: {
    width: "20%",
    margin: "0 0 0 auto",
    padding: "16px 0",
  },
  theShirtIcon: {
    position: 'fixed',
    bottom: "1rem",
    right: "1rem",
  },
  theSIImage: {
    position: 'relative',
    width: "50px",
    height: '50px',
    '& img': {
      width: "100%",
    }
  },
  theFloatCart: {
    position: 'fixed',
    bottom: "5rem",
    right: "1rem",
    width: "450px",
    background: "#fff",
    borderRadius: "10px",
    boxShadow: "rgb(0 0 0 / 24%) 0px 3px 8px"
  },
  theFloatCartBig: {
    position: 'fixed',
    bottom: "5rem",
    right: "1rem",
    width: "650px",
    background: "#fff",
    borderRadius: "10px",
    boxShadow: "rgb(0 0 0 / 24%) 0px 3px 8px"
  },
  theFCHeader: {
    padding: "16px",
    background: "#1A5386",
    borderRadius: "10px 10px 0px 0px"
  },
  theFCTable: {
    padding: "16px",
  },
  theCartTitle: {
    borderBottom: '1px solid #000!important'
  },
  theFCFooter: {
    borderTop: '1px solid #000',
    padding: "16px",
    display: "flex",
    justifyContent: "flex-end"
  },
  theCheckoutBtn: {
    width: "40%",
    margin: "0 0 0 auto",
  },
};

export default makeStyles(config);
